import { createFileRoute } from "@tanstack/react-router";
import { PulseConfigurator } from "@/pages/pulse/configure";

export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/pulse/configure')({
  component: PulseConfigurator,
})
